// Moment comes bundled with english which cannot be removed, so no need to import it

let messagesPromise;

if (process.env.NODE_ENV === "production") {
    messagesPromise = import(/* webpackChunkName: "en-generated", webpackMode: "eager" */ "@/i18n/translations/en.generated.js").then(
        generatedLanguageModule => {
            return generatedLanguageModule.default;
        }
    );
} else {
    messagesPromise = import(/* webpackChunkName: "language-development", webpackMode: "eager" */ "@/i18n/language.development").then(
        generatorModule => {
            return generatorModule.generate("en");
        }
    );
}

export default messagesPromise;
